import { Match } from 'effect';

import { BANNER_LISTING_PLACEMENT_1_ROW, BANNER_LISTING_PLACEMENT_2_ROW } from '../config/banner';

import type { Banner, BannerPlacement } from '../effect/schema/openapi/backend';
import { BannerPlacementType } from '../enum/bannerPlacement';

function getBannerPlacement(banner: Banner, placement: BannerPlacement): boolean {
  const bannerPlacement = banner.placement;

  return Match.value(bannerPlacement).pipe(
    Match.when(BannerPlacementType.HOMEPAGE, () => placement === BannerPlacementType.HOMEPAGE),
    Match.when(
      BannerPlacementType.CATEGORY_LISTING_1,
      () => placement === BannerPlacementType.CATEGORY_LISTING_1
    ),
    Match.when(
      BannerPlacementType.CATEGORY_LISTING_2,
      () => placement === BannerPlacementType.CATEGORY_LISTING_2
    ),
    Match.when(
      BannerPlacementType.CATEGORY_FOOTER,
      () => placement === BannerPlacementType.CATEGORY_FOOTER
    ),
    Match.when(
      BannerPlacementType.PRODUCT_UNDER_GALLERY,
      () => placement === BannerPlacementType.PRODUCT_UNDER_GALLERY
    ),
    Match.when(
      BannerPlacementType.PRODUCT_MAIN_INFO,
      () => placement === BannerPlacementType.PRODUCT_MAIN_INFO
    ),
    Match.when(
      BannerPlacementType.CUSTOMER_GUIDE,
      () => placement === BannerPlacementType.CUSTOMER_GUIDE
    ),
    Match.when(
      BannerPlacementType.CATEGORY_DESCRIPTION,
      () => placement === BannerPlacementType.CATEGORY_DESCRIPTION
    ),
    Match.exhaustive
  );
}

/**
 * Filter banners by placement using exhaustive matching.
 *
 * @param banners - Array of banners to filter
 * @param placement - Banner placement to filter by (prefer using BannerPlacementType enum values)
 * @returns Filtered array of banners matching the specified placement
 *
 * @example
 * ```ts
 * import { BannerPlacementType } from '@rcprofi/enum/bannerPlacement';
 * const footerBanners = filterBannersByPlacement(banners, BannerPlacementType.CATEGORY_FOOTER);
 * ```
 */
export function filterBannersByPlacement<T extends Banner>(
  banners: readonly T[],
  placement: BannerPlacement
): readonly T[] {
  return banners.filter((banner) => getBannerPlacement(banner, placement));
}

export function filterBannersByPlacementAndSortByPriority<T extends Banner>(
  banners: readonly T[],
  placement: BannerPlacement
): ReadonlyArray<T> {
  return filterBannersByPlacement(banners, placement).toSorted((a, b) => a.priority - b.priority);
}

//end of row
export function getFirstBannerPlacementInProductList(columnCount: number): number {
  if (columnCount === 4) {
    return columnCount * BANNER_LISTING_PLACEMENT_1_ROW - 2;
  }
  return columnCount * BANNER_LISTING_PLACEMENT_1_ROW - 1;
}

//beginning of row
export function getSecondBannerPlacementInProductList(columnCount: number): number {
  if (columnCount === 4) {
    return columnCount * BANNER_LISTING_PLACEMENT_2_ROW - columnCount - 2;
  }
  return columnCount * BANNER_LISTING_PLACEMENT_2_ROW - columnCount - 1;
}
